import { FormattedMessage } from "react-intl";
import CopyIcon from "../../../components/Common/SvgIcons/TableIcons/CopyIcon";
import DeleteIcon from "../../../components/Common/SvgIcons/TableIcons/DeleteIcon";
// import DownloadIcon from "../../../components/Common/SvgIcons/TableIcons/DownloadIcon";
import EditIcon from "../../../components/Common/SvgIcons/TableIcons/EditIcon";
import Tooltip from "../../../components/Common/ToolTip/Tooltip";
// import VariantIcon from "../../../components/Common/SvgIcons/TableIcons/VariantIcon";
import { tableColumnTypes } from "../../tableColumnTypes";
import { createShotclasses } from "./createShotclasses";
import RoleMenuChek from "../../../hoc/RoleMenuCheck";
import { roleMenuList } from "../../roleMenuList";

export const publishedByMe = {
  label: <FormattedMessage id="MYCLASS_PUBLISHEDBYME" />,
  path: (tenantName) => `/${tenantName}/manage/publishedByMe`,
  searchPlaceHolder: "Search published by me by name or tag",
  columns: (navigate, handleDeleteModal, tenantName) => [
    {
      ID: 1,
      name: <FormattedMessage id="Report_ShotClass_Name" />,
      fieldName: "Name",
      value: (row) => (
        <div title={row?.Name}>
          {row?.Name?.length > 25 ? row?.Name?.slice(0, 23) + "..." : row?.Name}
        </div>
      ),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="MYCLASS_DATEMODIFY" />,
      fieldName: "ModifiedDate",
      value: (row) => row.ModifiedDate,
      sort: true,
      type: tableColumnTypes.DATE,
    },
    {
      ID: 3,
      name: <FormattedMessage id="MyClassStatus_lbl" />,
      fieldName: "IsDistributed",
      value: (row) => (row.IsDistributed ? "Distributed" : "Published"),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 4,
      name: <FormattedMessage id="MyClassVideoUploadStatus_lbl" />,
      fieldName: "VideoUploadStatus",
      value: (row) =>
        row.VideoUploadStatus === 0
          ? "Not Available"
          : row.VideoUploadStatus === 1
          ? "In Progress"
          : row.VideoUploadStatus === 2
          ? "Failed"
          : row.VideoUploadStatus === 3
          ? "Processed"
          : "",
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 5,
      name: <FormattedMessage id="MYCLASS_LANGUAGE" />,
      fieldName: "LocaleDisplay",
      value: (row) => row.LocaleDisplay,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 6,
      name: <FormattedMessage id="Cer_Actions" />,
      fieldName: "",
      value: (row) => (
        <>
          {/* <DownloadIcon /> */}
          <Tooltip
            content={<FormattedMessage id="MYCLASS_DELETE" />}
            direction={"bottom"}
            show={!row.IsDistributed}
          >
            <span
              onClick={() => handleDeleteModal(row.ID)}
              style={{ visibility: !row.IsDistributed ? "visible" : "hidden" }}
            >
              <DeleteIcon />
            </span>
          </Tooltip>
          {/* <span
            style={{ visibility: row.Mediatype !== 8 ? "visible" : "hidden" }}
            onClick={() =>
              navigate(`${createShotclasses.variantPath}/${row.ID}`)
            }
          >
            <VariantIcon />
          </span> */}
          <RoleMenuChek
            feature={[
              {
                roleMenu: roleMenuList?.MANAGE?.EDIT_SHOTCLASS,
                MSOMMenu: "",
              },
            ]}
          >
            <Tooltip
              content={<FormattedMessage id="MYCLASS_EDIT" />}
              direction={"bottom"}
            >
              <span
                onClick={() => {
                  localStorage.setItem("shotclassTypeFrom", "publishedByMe");
                  navigate(
                    `${createShotclasses.editpath(tenantName)}/${row.ID}`,
                    {
                      state: { from: "publishedByMe" },
                    }
                  );
                }}
              >
                <EditIcon />
              </span>
            </Tooltip>
            <Tooltip
              content={<FormattedMessage id="MYCLASS_COPY" />}
              direction={"bottom"}
            >
              <span
                onClick={() => {
                  localStorage.setItem("shotclassTypeFrom", "publishedByMe");
                  navigate(
                    `${createShotclasses.copypath(tenantName)}/${row.ID}`,
                    {
                      state: { from: "publishedByMe" },
                    }
                  );
                }}
              >
                <CopyIcon />
              </span>
            </Tooltip>
          </RoleMenuChek>
        </>
      ),
      sort: false,
    },
  ],
};
